var map = {
	"./events-cat-cn.webp": 2009,
	"./events-cat.webp": 2010,
	"./games-cat.webp": 2011,
	"./live-casino-cat-cn.webp": 2012,
	"./live-casino-cat.webp": 2013,
	"./lottery-cat.webp": 2014,
	"./other-cat.webp": 2015,
	"./p2p-cat.webp": 2016,
	"./pd-table.webp": 2017,
	"./privacy-policy-title-bm.webp": 2018,
	"./privacy-policy-title-cn.webp": 2019,
	"./privacy-policy-title-id.webp": 2020,
	"./privacy-policy-title.webp": 2021,
	"./promos-1.webp": 2022,
	"./promos-2.webp": 2023,
	"./promos-3.webp": 2024,
	"./promos-4.webp": 2025,
	"./question.webp": 2026,
	"./sideBar-bg.webp": 2027,
	"./slot-cat-cn.webp": 2028,
	"./slot-cat.webp": 2029,
	"./special-cat-cn.webp": 2030,
	"./special-cat.webp": 2031,
	"./sports-cat-cn.webp": 2032,
	"./sports-cat.webp": 2033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;